import React from 'react';
import cx from 'classnames';
import bcx from 'bem-classname';
export var HeaderBrand = function (props) {
    var componentClass = 'header';
    var elementClass = 'brand';
    var className = props.className, children = props.children;
    var classes = cx(className, bcx(componentClass, elementClass));
    return React.createElement("div", { className: classes }, children);
};
//# sourceMappingURL=HeaderBrand.js.map